import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { MessagesService } from '../messages.service';

@Component({
  selector   : 'confirmation-hard',
  template: require('./confirmation.hard.component.html')
})
export class ConfirmationHardComponent {
  @Input() message: string;
  @Input() type   : string;

  code     : number = Math.round(Math.random()*10000);
  typedCode: number | string;

  constructor (
    public  activeModal     : NgbActiveModal,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  confirm () : void {
    this.code.toString() === this.typedCode.toString()
      ? this.activeModal.close()
      : this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.CODE_DOES_NOT_MATCH'), 'error');
  }
}
